import React, { PureComponent } from 'react'
import { connect } from 'react-redux'

import { Avatar } from '@driftt/tide-core-legacy'
import { teamMembers } from 'app/modules/teams/selectors'

import './style'

class TeamAvatarList extends PureComponent {
  getUserTitle = user => user.name || user.email || user.alias

  render() {
    return (
      <div className="selected-team-members">
        {this.props.teamMembers.map((member, index) => (
          <div key={index} className="team-list-member">
            <Avatar user={member} />
            <span className="choice-option-value">{this.getUserTitle(member)}</span>
          </div>
        ))}
      </div>
    )
  }
}

const mapStateToProps = (state, props) => ({
  teamMembers: teamMembers(state, { teamId: props.teamId }),
})

export default connect(mapStateToProps)(TeamAvatarList)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/team/TeamAvatarList/index.js